const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OpsCart = require("../vault/OpsCart");
const OfficeModal = require("./OfficeModal");
const Cart = require("../checkout/Cart");
const Suggestions = require("../checkout/Suggestions");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const {atPage, atCart} = require("../../core/vault/StateCursors");
const Link = require("../../core/view/Link");
const URLMake = require("../../../shared/URLMake");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/CartModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		page: atPage(vaultState).get(),
		cart: atCart(vaultState).get(),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CartModal",

		propTypes: {
			// Injected by HOCs
			page: PT.object.isRequired,
			cart: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			itemsAddedToCart: function(data) {
				this.setState({
					isOpen: true,
					type: data.type,
					number: data.number,
					wasUpdated: false,
				});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
				number: 0,
				type: null,
				wasUpdated: false,
			};
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			if (this.props && this.props.page !== nextProps.page) {
				this.setState({isOpen: false});
			} else if (
				this.state.isOpen &&
				!_.isEqual(this.props.cart.items, nextProps.cart.items)
			) {
				this.setState({wasUpdated: true});
			}
		},

		UNSAFE_componentWillUpdate: function() {
			const cart = this.props.cart;
			if (this.state && this.state.isOpen && _.has(cart, "items")) {
				const itemsLength = cart.items.length;
				this.makeSmallRows = this.makeSmallRows || itemsLength > 8;
				if (this.itemsLength && itemsLength > this.itemsLength) {
					this.justAddedItem = true;
				}
				this.itemsLength = itemsLength;
			}
			this.continueButtons = [];
		},

		componentDidUpdate: function() {
			// Remove initial focus from "Continue Shopping" buttons
			if (this.continueButtons) {
				this.blurContinueButtons();
			}
			if (this.justAddedItem && this.cartThingsView) {
				this.justAddedItem = false;
				const rowHeightRems = this.makeSmallRows ? 5 : 8.5;
				const pos = this.cartThingsView.scrollTop;
				const fontSize = parseInt(
					window.getComputedStyle(document.body).getPropertyValue("font-size")
				);
				const borderSize = 2;
				// TODO: Doesn't push modal down far enough.
				this.cartThingsView.scrollTop =
					pos + rowHeightRems * fontSize + borderSize;
			}
		},

		onClose: function() {
			this.setState(this.getInitialState());
		},

		onKeyPressClose: function(evt) {
			if (evt.which === 13) {
				this.onClose();
			}
		},

		//This is to handle going checkout button "click" on enter (when tabbing)
		goToCheckout: function(evt) {
			if (evt.which === 13) {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forCheckoutStep("review"),
					addToHistory: true,
				});
			}
		},

		blurContinueButtons: function() {
			_.each(this.continueButtons, button => {
				button.blur();
			});
		},

		renderBundleRecommendation: function() {
			const items = this.props.cart.items;
			const hasSubs = OpsCart.hasSubscriptionItems(items);
			if (hasSubs) return null;
			const gradeSet = OpsCart.getUnbundledBookSets(items);
			if (!gradeSet.length) return null;
			const bundleInfo = OpsCart.getBundleInfo(gradeSet[0]);
			if (!bundleInfo) return null;
			const grade = bundleInfo.gradeNumber;
			return CopyTable.getBundleRecommendationsCopy(styles, grade);
		},

		render: function() {
			if (this.state.isOpen) {
				const makeButtons = set => {
					return (
						<div className={styles.buttons}>
							<div
								className={styles.button}
								onClick={this.onClose}
								onContextMenu={this.blurContinueButtons}
								tabIndex={set}
								onKeyPress={this.onKeyPressClose}
								ref={v => {
									if (v) {
										this.continueButtons.push(v);
									}
								}}
							>
								Continue Shopping
							</div>
							<div
								className={styles.button}
								tabIndex={set + 1}
								onKeyPress={this.goToCheckout}
							>
								<Link className={styles.buttonLink} to={URLMake.forCheckout()}>
									Checkout
								</Link>
							</div>
						</div>
					);
				};
				const bundleRecommendation = this.renderBundleRecommendation();
				let titleMessage;
				if (this.state.wasUpdated) {
					titleMessage = "Your cart has been updated.";
				} else {
					// If we ever have different types of apparel, we may need to add additional logic here.
					const typeText =
						(this.state.type === "apparel" ? "shirt" : this.state.type) +
						(this.state.number > 1 ? "s" : "");
					titleMessage =
						"You added " +
						this.state.number +
						" " +
						typeText +
						" to your cart.";
				}
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						modalClass={styles.main}
						isScrollable={true}
						scrollTopOnOpen={true}
					>
						<div className={styles.container}>
							<div className={styles.added}>{titleMessage}</div>
							{makeButtons(10)}
							{bundleRecommendation}
							<div
								className={styles.cartThings}
								ref={v => (this.cartThingsView = v)}
							>
								<Cart
									cart={this.props.cart}
									inModal={true}
									tabIndexStart={20}
								/>
								<Suggestions
									cart={this.props.cart}
									inModal={true}
									className={styles.suggestions}
									tabIndexStart={1000}
								/>
							</div>
							{bundleRecommendation}
							{makeButtons(1010)}
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
